import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import Service from "@/services/AsesmenPraBedah";

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "asesmen-pra-bedah"
})
class AsesmenPraBedahStoreModule extends VuexModule {
  loading = false;
  dataList: any[] = [];
  masters: any = { rcri: [], caprini: [], stopbang: [], asa: {} };

  @Mutation
  SET_DATALIST(val: any[]) {
    this.dataList = val;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation
  SET_MASTERS(val: any) {
    this.masters = val;
  }

  @Mutation
  RESET_STORE() {
    this.dataList = [];
  }

  @Action({ rawError: true })
  async getByRegister(registerId: string | number): Promise<void> {
    this.SET_LOADING(true);

    const response = await Service.getByRegister(registerId).finally(() => {
      this.SET_LOADING(false);
    });

    this.SET_DATALIST(response?.data || []);
  }

  @Action({ rawError: true })
  async loadMasters(): Promise<void> {
    if (this.masters && this.masters.caprini && this.masters.caprini.length) {
      return;
    }
    const response = await Service.masters();
    this.SET_MASTERS(response?.data || { rcri: [], caprini: [], stopbang: [], asa: {} });
  }

  @Action({ rawError: true })
  reset(): void {
    this.RESET_STORE();
  }
}

export default getModule(AsesmenPraBedahStoreModule);
